<template>
	<div class="">
		<b-button @click="showPopup()" :class="class_style">
			<i class="fas fa-download pr-1"></i> <span v-text="text"></span>
		</b-button>

		<b-modal id="modal-downloadcsv" ref="modal_downloadcsv" title="Download CSV Data" hide-footer>
			<div class="row mb-1">
				<label class="col-2">From:</label>
				<div class="col-10">
					<b-form-datepicker
						placeholder="Start Date"
						v-model="dates.start.selected"
						:min="dates.start.min"
						:max="dates.start.max"
					>
					</b-form-datepicker>
				</div>
			</div>

			<div class="row mb-1">
				<label class="col-2">To:</label>
				<div class="col-10">
					<b-form-datepicker
						placeholder="End Date"
						v-model="dates.end.selected"
						:min="dates.end.min"
						:max="dates.end.max"
					>
					</b-form-datepicker>
				</div>
			</div>

			<!-- <div class="row mb-1">
				<label class="col-2">Range:</label>
				<div class="col-10">
					<b-form-select v-model="range_select" :options="range_options"> </b-form-select>
				</div>
			</div> -->

			<!-- <div class="row mb-1">
				<label class="col-2">Data:</label>
				<div class="col-10">
					<b-form-group v-slot="{ ariaDescribedby }">
						<b-form-checkbox-group
							v-model="options_selected"
							:options="options_include"
							:aria-describedby="ariaDescribedby"
							name="data_types"
						></b-form-checkbox-group>
					</b-form-group>

					<p v-if="options_selected === ''" class="small text-danger">
						* Select data type to download
					</p>
				</div>
			</div> -->

			<div v-if="loading == 0" class="text-center w-100">
				<hr />
				<p class="small">{{ profile.user_name }}'s data</p>
				<JsonCSV
					v-if="json_export_data.length > 0"
					:data="json_export_data"
					:class="class_style"
					:name="filename"
				>
					<i class="fas fa-download"></i> Download CSV
				</JsonCSV>
			</div>
			<div v-else class="text-center">
				<i class="fas fa-spinner fa-spin"></i>
			</div>

			<p v-if="loading == 0 && json_export_data.length == 0" class="text-center">
				Nothing to Download
			</p>
		</b-modal>
	</div>
</template>

<script>
import axios from 'axios';
import JsonCSV from 'vue-json-csv';

export default {
	name: 'DownloadCSVButton',
	components: {
		JsonCSV,
	},
	props: {
		class_style: {
			type: String,
			default: 'btn btn-outline-primary',
		},
		jsonData: {
			type: Array,
			default: null,
		},
		text: {
			type: String,
			default: 'Download CSV',
		},
		userid: {
			type: Number,
			default: null,
		},
	},
	data() {
		const today = new Date().toISOString().slice(0, 10);
		let date = new Date();
		let month = new Date().getMonth();
		const startDate = new Date(date.setMonth(month - 1)).toISOString().slice(0, 10);

		return {
			dates: {
				end: {
					min: null,
					max: today,
					selected: today,
				},
				start: {
					min: null,
					max: today,
					selected: startDate,
				},
			},
			filename: 'community_data.csv',
			loading: 0,
			options_include: [
				{ text: 'Body', value: 'body' },
				{ text: 'Focus', value: 'focus' },
				{ text: 'Meditation', value: 'meditation' },
				{ text: 'Sleep', value: 'sleep' },
			],
			options_selected: ['body', 'focus', 'meditation', 'sleep'],
			profile: {
				user_name: 'Community',
			},
			json_export_data: [],
			rawData: [],

			range_options: [
				{ value: 'Monthly', text: 'Monthly' },
				{ value: 'Weekly', text: 'Weekly' },
				{ value: 'Daily', text: 'Daily' },
			],
			range_select: 'Daily',
		};
	},

	computed: {},

	methods: {
    showPopup() {
      this.$refs['modal_downloadcsv']?.show()
      this.loadData()
    },
		loadData() {
			console.log('loadData');
			let _this = this;
			_this.loading = 1;
			_this.json_export_data = [];

			if (this.jsonData !== null) {
				console.log('passed data');
			} else {
				console.log('fetch data');
				let params = new URLSearchParams();
				params.append('token', this.$store.state.session_id);
				params.append('start_date', this.dates.start.selected);
				params.append('end_date', this.dates.end.selected);
				/*params.append('range', this.range_select);*/
				params.append('user_id', this.userid);
				params.append('options', this.options_selected);

				this.createFilename(this.userid);

				axios({
					url: _this.$store.state.api_url + 'profileReportCSV',
					params: params,
				})
					.then(function (response) {
						if (response.data.csv) {
							const entries = Object.values(response.data.csv);

							for (const obj of entries) {
								_this.json_export_data.push(obj);
							}
						}
						_this.loading = 0;
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},

		createFilename(userid) {
			let _this = this;
			console.log('createFilename:' + userid);

			_this.filename =
				'community_data_' +
				_this.dates.start.selected +
				'-TO-' +
				_this.dates.end.selected +
				'.csv';

			if (userid !== null) {
				let params = new URLSearchParams();
				params.append('token', this.$store.state.session_id);
				params.append('user_id', userid);

				axios({
					url: _this.$store.state.api_url + 'memberGetProfile',
					params: params,
				})
					.then(function (response) {
						if (response.data.profile.uri) {
							_this.profile = response.data.profile;
							_this.filename =
								response.data.profile.uri +
								'-' +
								_this.dates.start.selected +
								'-TO-' +
								_this.dates.end.selected +
								'.csv';
						}
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},
	},

	watch: {
		options_selected: {
			deep: true,
			handler() {
				this.loadData();
			},
		},
		dates: {
			deep: true,
			handler() {
				this.loadData();
			},
		},
	},
};
</script>

<style scoped></style>
